import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { EcmRouterModule, ExtendedLinkService, Link, LinkService, TrackingData } from '@ecm/router';

import { ContractV7Offer } from '../../../business/api/dashboardV7/contract/contractV7Offer';

@Component({
    selector: 'ecm-section-offer',
    templateUrl: 'section-offer.component.html',
    styleUrls: ['section-offer.component.css'],
    standalone: true,
    imports: [RouterLink, AsyncPipe, EcmRouterModule, TranslateModule],
})
export class SectionOfferComponent {
    @Input()
    public offer!: ContractV7Offer;

    public extendedLinkService: ExtendedLinkService = inject(ExtendedLinkService);
    public linkService: LinkService = inject(LinkService);

    public openLink(link: Link, tmsTracking: TrackingData) {
        this.linkService.openLink(link, tmsTracking);
    }
}
